import React from "react";
import SelectInput from "../../../../components/inputs/SelectInput";
import FractionInput from "../../../../components/inputs/FractionInput";
import { InlineMath, BlockMath } from "react-katex";

function getRandomInt(min, max, excludeZero = false) {
  let num;
  do {
    num = Math.floor(Math.random() * (max - min + 1)) + min;
  } while (excludeZero && num === 0);
  return num;
}

export function generateTask() {
  const rand = Math.random();

  let a;
  if (rand < 0.25) {
    a = 0;
  } else {
    a = randomFrom([-3, -2, -1, 1, 2, 3]);
  }

  const b = randomInt(-5, 5);

  const formulaLatex = `a_n = ${a !== 0 ? a + "n" : ""}${b > 0 ? ` + ${b}` : b < 0 ? ` - ${-b}` : ""}`;

  return {
    type: "CheckMonotonicityFromDifferenceTask",
    a,
    b,
    data: {
      formulaLatex,
    },
    answer: {
      difference: a.toString(),
      monotonicity: a > 0 ? "rosnący" : a < 0 ? "malejący" : "stały"
    }
  };
}



export function renderTask({ a, b }) {
  return (
    <div className="space-y-2">
      <p>Rozważ ciąg określony wzorem:</p>
      <BlockMath math={`a_n = ${a}n ${b >= 0 ? "+ " + b : "- " + Math.abs(b)}`} />
      <p>Oblicz wyrażenie <InlineMath math="a_{n+1} - a_n" /> i na tej podstawie określ monotoniczność ciągu.</p>
    </div>
  );
}

export function renderInput(task, userAnswer, setUserAnswer, disabled) {
  return (
    <div className="space-y-4">
      <div>
        <p>Wartość wyrażenia <InlineMath math="a_{n+1} - a_n" />:</p>
        <FractionInput
          value={userAnswer?.difference || ""}
          onChange={(val) =>
            setUserAnswer({ ...userAnswer, difference: val.raw })
          }
          label="a_{n+1} - a_n"
        />
      </div>

      <div className="mt-2">
        <p>Monotoniczność ciągu:</p>
<SelectInput
options={[
  { value: "rosnący", label: "rosnący" },
  { value: "malejący", label: "malejący" },
  { value: "stały", label: "stały" }
]}
  value={userAnswer?.monotonicity || ""}
  onChange={(e) =>
    setUserAnswer({ ...userAnswer, monotonicity: e.target.value })
  }
/>

      </div>
    </div>
  );
}


export function checkAnswer({ answer }, userAnswer) {
  if (!userAnswer || !userAnswer.difference || !userAnswer.monotonicity)
    return false;

  const simplified = userAnswer.difference.replace(/\s/g, "");
  const expected = answer.difference.toString();

  const correctDifference =
    simplified === expected || parseFloat(simplified) === answer.difference;

  const correctMonotonicity =
    userAnswer.monotonicity === answer.monotonicity;

  return correctDifference && correctMonotonicity;
}

export function renderAnswer(task) {
  const { answer } = task;

  if (!answer || !answer.difference || !answer.monotonicity) {
    return <i>(brak odpowiedzi)</i>;
  }

  return (
    <div className="space-y-1">
      <div>
        <strong>Różnica:</strong>{" "}
        <InlineMath math={`a_{n+1} - a_n = ${answer.difference}`} />
      </div>
      <div>
        <strong>Monotoniczność:</strong> {answer.monotonicity}
      </div>
    </div>
  );
}




export function renderUserAnswer(userAnswer) {
  if (
    !userAnswer ||
    userAnswer.difference?.trim() === "" ||
    !userAnswer.monotonicity
  ) {
    return <i>(brak odpowiedzi)</i>;
  }

  return (
    <div className="space-y-1">
      <div>
        <strong>Wartość różnicy:</strong>{" "}
        <InlineMath math={`a_{n+1} - a_n = ${userAnswer.difference}`} />
      </div>
      <div>
        <strong>Monotoniczność:</strong> {userAnswer.monotonicity}
      </div>
    </div>
  );
}

export function renderExplanation(task) {
  const { answer } = task;
  const a = parseFloat(answer.difference);
  const b = task.data?.b ?? 0;

  return (
    <div className="space-y-2" style={{ textAlign: "left" }}>
      <p>
        Mamy wzór: <InlineMath math={`a_n = ${a}n ${b >= 0 ? "+ " + b : "- " + Math.abs(b)}`} />
      </p>
      <p>
        Obliczamy <InlineMath math="a_{n+1} - a_n" />:
      </p>
      <BlockMath math={`a_{n+1} = ${a}(n + 1) ${b >= 0 ? "+ " + b : "- " + Math.abs(b)}`} />
      <BlockMath math={`a_n = ${a}n ${b >= 0 ? "+ " + b : "- " + Math.abs(b)}`} />
      <BlockMath math={`a_{n+1} - a_n = ${a}(n + 1) + ${b} - (${a}n + ${b})`} />
      <BlockMath math={`= ${a}n + ${a} + ${b} - ${a}n - ${b}`} />
      <BlockMath math={`= ${a}`} />
      <p>
        Różnica jest równa {a > 0 ? "liczbie dodatniej" : a < 0 ? "liczbie ujemnej" : "zero"}, więc ciąg jest{" "}
        <strong>{answer.monotonicity}</strong>.
      </p>
    </div>
  );
}

function randomFrom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
